import createIcon from '../../createIcon';

/**
 * @component @name FlashOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyVjEzSDEwVjIyTDE3IDEwSDEzTDE3IDJIN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FlashOn = createIcon('FlashOn', [
  ['path', { d: 'M7 2V13H10V22L17 10H13L17 2H7Z', key: 'ejovkr' }],
]);

export default FlashOn;
